import {Pipe, PipeTransform} from '@angular/core';
import {Utils} from "../utils/utils";

@Pipe({
    name: 'trimHomeUrl',
    standalone: false
})
export class TrimHomeUrlPipe implements PipeTransform {

  transform(url: string, homeUrl: any = {}): string {
    return Utils.trimHomeUrl(url, homeUrl);
  }

}
